import styled, { css } from 'styled-components';

export const Container = styled.div`
   display: flex;
   align-items: center;

   .check--{
      display: flex;
      width: 60px;
      height: 100%;
      justify-content: center;
      align-items: center;
      padding: 0.33rem;
      margin-bottom: 1rem;
   }

   ${({ isMessageSelected }) => isMessageSelected &&
      css`
         background-color: #dbcfc4;

      `
   }
   
   .content-{
      width: 100%;
   }
   
`;

export const Line = styled.div`
   display: flex;
   text-align: center;   
   justify-content: ${({ isUserSystem }) => isUserSystem ? 'flex-end' : 'flex-start'};
   width: 100%;
   margin-bottom: 1rem;
`
export const MessageWrapper = styled.div`
   max-width: 80%;
`
export const MessagePeriod = styled.div`
   display: flex;
   width: 100%;
   text-align: center;   
   justify-content: center;
   padding: 1rem;
   span{
      display: flex;
      background-color: rgba(0, 0, 0, .10);
      border-radius: 6px;
      padding: 10px;  
      font-size: 14px;
      font-weight: bolder;
      box-shadow: 0 1px 1px #b5b5b5;
   }
`
